import type { LessonLink } from "@/shared/data/lessons";

type Platform = "ios" | "android" | "desktop";
export type Store = "app_store" | "google_play";

interface ReferralEventParams {
  referral_code: string;
  display_name: string;
  platform: Platform;
  tracking_source?: string;
  reward_details_available: 0 | 1;
  reward_type?: string;
  inviter_reward_amount?: number;
  invitee_reward_amount?: number;
  total_reward_amount?: number;
}

// Mirrors the gtag() function created by GA4's init snippet.
// Pushes the `arguments` object (not an array) — this is how gtag.js
// processes queued events from the dataLayer.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function gtag(_command: "event", _eventName: string, _params: object) {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export function trackReferralLanded(params: ReferralEventParams) {
  gtag("event", "referral_landed", params);
}

export function trackAcceptInviteClick(params: ReferralEventParams) {
  gtag("event", "referral_accept_invite_click", params);
}

export function trackLinkCopy(
  params: ReferralEventParams & { success: boolean },
) {
  gtag("event", "referral_link_copy", params);
}

export function trackAppStoreRedirect(
  params: ReferralEventParams & { store: Store },
) {
  gtag("event", "referral_app_store_redirect", params);
}

export function trackStoreBadgeClick(
  params: ReferralEventParams & { store: Store },
) {
  gtag("event", "referral_store_badge_click", params);
}

export function trackInstallStoreClick(params: {
  store: Store;
  placement: string;
  page_path: string;
}) {
  gtag("event", "store_badge_click", params);
}

export function trackLearnInstallClick(params: {
  store: Store;
  placement: "hub" | "article";
  page_type: "learn_hub" | "learn_article";
  lesson_slug?: string;
}) {
  gtag("event", "learn_install_click", params);
}

export function trackLearnProductClick(params: {
  product: NonNullable<LessonLink["product"]>;
  destination: string;
  lesson_slug: string;
  page_path: string;
}) {
  gtag("event", "learn_product_click", params);
}
